var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPickup = function SvgPickup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8241 5H21.156M3.8241 9.14941V18.8389C3.8241 19.2015 4.0599 19.4432 4.41362 19.4432H20.5665C20.8612 19.4432 21.156 19.2015 21.156 18.8389V9.14941",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6797 8.87635L9.60107 5H21.2301L22.9717 8.2022C23.2525 8.65163 22.8593 9.2696 22.3537 9.2696H12.2977C12.0168 9.2696 11.7921 9.15724 11.6797 8.87635Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89412 8.87635L9.60076 5H3.28529L1.02976 8.25838C0.729026 8.70781 1.18013 9.32578 1.85679 9.32578H6.0671C6.44302 9.2696 6.74375 9.10106 6.89412 8.87635Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60107 19.4432V5",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
};

export default SvgPickup;